export const iconFontAwesomeGamingChessPawn = (
	<i className="fa-solid fa-chess-pawn"></i>
);
